
export const actionTypes = {
  SET_SHOW_WELLNESS_UPSELL: "SET_SHOW_WELLNESS_UPSELL",
};

const setShowWellnessUpsell = (payload: boolean) => ({
  type: actionTypes.SET_SHOW_WELLNESS_UPSELL,
  payload,
});

export default {
  setShowWellnessUpsell,
};
